// AUTO-GENERATED from GetYourGuide reviews. Real customer reviews + photos.
// Sorted newest-first. Regenerate via the scraping script rather than editing by hand.

export interface Review {
    id: number;
    name: string;
    location: string;
    date: string;
    rating: number;
    content: string;
    fullContent?: string;
    images?: string[];
    verified: boolean;
    trip?: 'austria' | 'slovakia';
}

export const austriaReviews: Review[] = [
    {
        id: 1,
        name: "Vasileia",
        location: "Greece",
        date: "May 11, 2026",
        rating: 4,
        content: "Everything was great, the guide and the driver did a really good job! I have to note that we didn’t go to Hallstatt as the title of the activity indicates, instead we visited another beautiful village. In any case as a customer you should make it clear with the planners of the activity if Hallstatt will be in the plan before booking, if this destination is your main interest.",
        images: ["/reviews/3bd246f0a83d.jpg", "/reviews/4eb6a10f9041.jpg", "/reviews/2b6dc62f1065.jpg", "/reviews/a672e9323f30.jpg"],
        verified: true,
    },
    {
        id: 2,
        name: "Alessio",
        location: "Italy",
        date: "May 3, 2026",
        rating: 5,
        content: "Bellissima esperienza, guide professionali e molto disponibili. Tour consigliato",
        verified: true,
    },
    {
        id: 3,
        name: "Kate",
        location: "United States",
        date: "May 2, 2026",
        rating: 5,
        content: "This was a great day trip and would definitely recommend! Richard was a very knowledgeable guide and a great driver. We were unable to go to Hallstatt due to restrictions on day tours, so we instead explored the Traunsee lake area and it ended up being one of our favorite parts of the trip! We were able to rent a small boat and go out on the water ourselves which was a highlight of the day!",
        verified: true,
    },
    {
        id: 4,
        name: "Parshav",
        location: "United States",
        date: "April 17, 2026",
        rating: 5,
        content: "It’s was the best day trip we have ever been on. Richard was on time and picked up us from the hotel and showed us the around all day. He gave us a great history of the places he took us to. He is a really prepared and organized guide and he knows the best spots in the areas. 10/10 all around and would definitely recommend the tour and Richard to be your tour guide to everyone.",
        verified: true,
    },
    {
        id: 5,
        name: "Kenneth",
        location: "Singapore",
        date: "December 19, 2025",
        rating: 5,
        content: "It was a wonderful day trip to the Wachau Valley, Melk Abbey and Salzburg. Even though I was the only person, the agent did not cancel on me. Richard, the guide was excellent. His explanation was clear and he provided a lot of information about the places we visited. Despite the long journey, he did not show any sign of being tired and drove safely throughout.",
        verified: true,
    },
    {
        // Manually added from Viator (Tripadvisor review) — not produced by the GetYourGuide scraper.
        id: 16,
        name: "A Tripadvisor Reviewer",
        location: "Viator",
        date: "December 2025",
        rating: 5,
        content: "The experience great! Both guides were very nice as well as being attentive to everything, the sites we visited and the time we were perfect, plus the very comfortable transportation. 100% recommended.",
        images: ["/reviews/viator-austria-1.jpg", "/reviews/viator-austria-2.jpg", "/reviews/viator-austria-3.jpg", "/reviews/viator-austria-4.jpg"],
        verified: true,
    },
    {
        id: 6,
        name: "Erik",
        location: "Netherlands",
        date: "December 7, 2025",
        rating: 5,
        content: "It was a great trip to beautiful valleys, the Melk monastery, the Traunsee and Salzburg. Tomas and Michael were really kind and good guides. they took time to explain about the different sight, and brought us to some of the less visited places alongst the way as well. I can really recommend their tours!",
        images: ["/reviews/6efb09ee483c.jpg", "/reviews/79d2a8e7f68f.jpg", "/reviews/3b9e9f3c8cc2.jpg", "/reviews/dee101bfec55.jpg"],
        verified: true,
    },
    {
        id: 7,
        name: "Arza",
        location: "Israel",
        date: "October 31, 2025",
        rating: 5,
        content: "It was an amazing trip! Breathtaking scenery, a wonderful atmosphere, and an unforgettable experience. Michael and Thomas were absolutely incredible - both as guides and as people. They were knowledgeable, kind, and always considerate. Thank you for the personal attention and care throughout the journey. We're already looking forward to the next adventures with you!",
        images: ["/reviews/3a18813fc1d6.jpg"],
        verified: true,
    },
    {
        id: 8,
        name: "Tomescu",
        location: "Romania",
        date: "October 30, 2025",
        rating: 5,
        content: "Amazing trip! We've seen absolutely beautiful landscapes of the Danube, mountains, lakes, churches, vineyards. We were enchanted with great stories by our guide Richard, thanks to whom all went according to plan, perfectly organized. Salzburg was mesmerizing-its gardens, castle, chic shops were worth the long drive!",
        images: ["/reviews/39d9d7739e8c.jpg", "/reviews/61b89bca500c.jpg", "/reviews/0dc976fea32d.jpg", "/reviews/f48b2ff56a1b.jpg"],
        verified: true,
    },
    {
        id: 9,
        name: "Myla",
        location: "United States",
        date: "October 21, 2025",
        rating: 5,
        content: "MUST DO TOUR!! Great value for your money, a very spacious van, safe driver, personalized tour, and the perfect balance between guided tour and time with your family/partner. We got to go to a yummy lunch just us 2 and take in the moment, while exploring many cities with a guide. There is something to be said about going with a newer/smaller company- it’s just better! You feel special. The hotel pickup was SO great. We had a blast. So glad we went with this company.",
        images: ["/reviews/c5a7448a2d95.jpg", "/reviews/7f78f48084fb.jpg", "/reviews/f1d7c61d89d2.jpg", "/reviews/088e775b25c0.jpg"],
        verified: true,
    },
    {
        id: 10,
        name: "Arya",
        location: "Canada",
        date: "October 8, 2025",
        rating: 5,
        content: "Michael and Richard were great and the trip was well planned! Good way to see many places in one day.",
        images: ["/reviews/158803e84b3c.jpg", "/reviews/1f41e0f19ea4.jpg", "/reviews/a2ee745883e0.jpg"],
        verified: true,
    },
    {
        id: 11,
        name: "Ingrid",
        location: "Canada",
        date: "October 8, 2025",
        rating: 5,
        content: "the trip was great! we made so many stops and our guide Michael and driver Richard were super friendly and helpful. it was definitely a long day but worth it as we got to see so many sites and learn a lot about the history of each place. unfortunately, it was rainy the day we went so we couldn’t go on a boat tour and instead, Michael improvised and brought us to the Red Bull museum which was a cool place to stop as well. overall would recommend!",
        images: ["/reviews/6ede42ebf411.jpg", "/reviews/bf49f7f9a617.jpg", "/reviews/1180d2f7f9f1.jpg", "/reviews/232fc0aaed6d.jpg"],
        verified: true,
    },
    {
        id: 12,
        name: "Julie",
        location: "United Kingdom",
        date: "September 30, 2025",
        rating: 5,
        content: "We enjoyed everything about the day. We particularly enjoyed the boat trip. The day was very good value for money and the transport was comfortable. Thomas and Michael were great as our tour guides, very knowledgeable, professional and respectful. Nice little extras such as wine chocolates and water. Would definitely recommend this trip",
        images: ["/reviews/f7e345762a71.jpg", "/reviews/e7d89916ce68.jpg", "/reviews/ff9e9f5678e4.jpg", "/reviews/0740052e7a9e.jpg"],
        verified: true,
    },
    {
        id: 13,
        name: "Maryann",
        location: "Malta",
        date: "September 29, 2025",
        rating: 5,
        content: "The trip was excellent planned out Started with the pick up from my location which was very convenient The private van was comfortable &clean The tour guides were knowledgeable with information on every place we visited and guided the tour on a comfortable pace we had enough time to take pictures and enjoy the moment Definitely will recommend this trip anytime, we visited both Wachau valley & Dürnstein more nature experience With the addition to the wine tasting Headed to melk abbey rich with heritage monastery & beautiful gardens Had lunch at Traunkirchen beautiful alp lake & mountains scenery was relaxing with a boat tour🙂 The guides provided multiple recommendations with places to dine which dint disappoint with reasonable prices lastly we drove to Salzburg city tour with Mirabell palace , every place was great The tour captured best part of Austria for a day trip moreover , the time was efficient and well planned out Thankyou Tomas & bro",
        images: ["/reviews/51f45da063e5.jpg", "/reviews/65cc92be4e21.jpg", "/reviews/1681e7d437ae.jpg", "/reviews/b8643533fee5.jpg"],
        verified: true,
    },
    {
        id: 14,
        name: "Ashley",
        location: "United States",
        date: "September 4, 2025",
        rating: 5,
        content: "This was without a doubt the best tour I have ever been on! The guide was extremely friendly, funny, and knowledgeable—a true professional who made the whole day exceptional. Every stop was absolutely breathtaking, from the Wachau vineyards to the majestic Melk Abbey and the charming streets of Salzburg. Traveling between destinations was very comfortable and everything was well organized. I left this tour feeling like I had experienced a rich part of Austria in one day. It's definitely worth it, and I recommend it without hesitation!",
        verified: true,
    },
    {
        id: 15,
        name: "Courtney",
        location: "United States",
        date: "August 20, 2025",
        rating: 5,
        content: "This day trip was fantastic! Martin, who was our driver and guide, and Michael, the co-owner of the company, could not have been better guides. They were professional, friendly, and incredibly accommodating, paying attention to all of our needs. There was ample time in each location, and all of the sights were stunning. We especially loved the scenery of the boat ride on the lake. I highly recommend this day trip!",
        verified: true,
    },
];

export const slovakiaReviews: Review[] = [
    {
        id: 1,
        name: "Valentina",
        location: "Italy",
        date: "June 12, 2026",
        rating: 4,
        content: "Soddisfatti della nostra gita fuori Bratislava, driver attento e premuroso. Ci siamo trovati benissimo e alla fine del tour siamo stati omaggiati di alcuni prodotti slovacchi🙂 Anche se il pranzo è facoltativo, ve lo consiglio di farlo perché si mangia abbastanza bene e non è per nulla caro. Abbiamo avuto un piccolo inconveniente con la programmazione, ma abbiamo risolto con l assistenza, anche loro premurosi e cortesi.",
        verified: true,
    },
    {
        id: 2,
        name: "Catherine",
        location: "United States",
        date: "May 7, 2026",
        rating: 5,
        content: "This was an excellent; thanks to our guide Richard, who made it not only interesting, but enjoyable. Next to Cerveny Kamen Castle and Beckon Castle, we were able to visit the town of Trencin and the iconic Cicmany Village, a famous traditional folk village and Moving Bethlehem, to finish with the Castle of Bratislava. Richard explained in great details each place we visited, always giving us time to explore these sites on our own once he provided all needed information. He is obviously very knowledgeable. We learned a great deal in the course of this day trip. Over all we love this tour and the company of our guide, and we highly recommend it !",
        verified: true,
    },
    {
        id: 3,
        name: "Anna",
        location: "Greece",
        date: "April 30, 2026",
        rating: 5,
        content: "Τέλεια εκδρομή, ο Richard o οδηγός - ξεναγός μας ήταν καταπληκτικός. Φρόντισε για ό,τι χρειαστήκαμε, με συνεχόμενη παροχή νερών, κέρασμα κρασιού. Ευτυχώς καταφέραμε και πήγαμε στο Χάλστατ, χωρίς να υπάρχει πρόβλημα με την αστυνομία.",
        verified: true,
    },
    {
        id: 4,
        name: "GetYourGuide traveler",
        location: "Spain",
        date: "April 27, 2026",
        rating: 5,
        content: "Perfect thanks to our guide Richard",
        images: ["/reviews/7adf21d06ba3.jpg", "/reviews/73c544f6d309.jpg"],
        verified: true,
    },
    {
        id: 5,
        name: "Caroline",
        location: "Brazil",
        date: "January 8, 2026",
        rating: 5,
        content: "Muito bom o passeio, mas poderíamos realmente entrar nos castelos e não apenas visitá-los do lado de fora. No entanto, adorei tudo. Guia muito simpático, conhece bastante, com muita didática e paciência. As vistas que ele nos mostrou são deslumbrantes.",
        verified: true,
    },
    {
        id: 6,
        name: "Patrizia",
        location: "Italy",
        date: "January 3, 2026",
        rating: 5,
        content: "Esperienza meravigliosa. Un tour nuovo, che permette di attraversare l'Austria scoprendo luoghi bellissimi e suggestivi. Il villaggio di Dürnstein che sembra essere uscito da un libro di fiabe, la storia della viticoltura di Wachau, l'escursione al lago di Traunsee con passeggiata che avvolge il lago per scoprirne il villaggio che lo accoglie, l'abbazia di Melk che ti sorprende con la sua architettura e la storia che la caratterizza fino ad arrivare a Salisburgo. Il tour è organizzato benissimo, il viaggio di andata e ritorno e relative tappe è stato molto confortevole. Tutto è stato possibile grazie alla nostra guida Richard, preparatissimo nella narrazione storica e di usi e costumi di ogni luogo che abbiamo visitato, professionale, molto gentile e attento e sempre disponibile a rispondere alle nostre domande/curiosità relative al tour e a fornirci suggerimenti per cosa visitare o dove mangiare nel tempo libero che avevamo a disposizione ad ogni tappa. Ancora grazie Richard.",
        verified: true,
    },
    {
        id: 7,
        name: "Hiriart",
        location: "France",
        date: "December 28, 2025",
        rating: 4,
        content: "Les visites étaient variées, sans précipitation malgré le peu d'heures de lumière diurne car en groupe très restreint (5 personnes)",
        verified: true,
    },
    {
        id: 8,
        name: "Marianna",
        location: "Italy",
        date: "December 12, 2025",
        rating: 5,
        content: "Un tour davvero pazzesco, che ha superato di gran lunga tutte le nostre aspettative! Abbiamo visitato luoghi meravigliosi, ognuno più suggestivo dell’altro. La nostra guida — e autista — Richard è stata una presenza impeccabile: preparatissimo, disponibile, gentile e sempre attento alle nostre esigenze. Ha arricchito ogni tappa con racconti, curiosità e spiegazioni davvero interessanti, rendendo l’esperienza ancora più speciale. Un viaggio che porteremo nel cuore e che consigliamo a chiunque voglia vivere qualcosa di unico. Ah e grazie per il regalo, graditissimo 😁",
        images: ["/reviews/8e69ab86081b.jpg", "/reviews/e477f1715d4d.jpg", "/reviews/6bd3ad681240.jpg", "/reviews/538faca8dfb1.jpg"],
        verified: true,
    },
    {
        id: 9,
        name: "Renzo",
        location: "Spain",
        date: "December 10, 2025",
        rating: 5,
        content: "Ha sido una experiencia muy buena, a superado toda mis expectativas de lo que yo creía, destacó la paciencia y buena onda de nuestro Guía Richard, siempre atento con las dudas de cada uno. Gracias a este tour he tenido la oportunidad de conocer más lo que es Eslovaquia, recomiendo mucho",
        images: ["/reviews/478b935d2cac.jpg", "/reviews/c063e6e82829.jpg", "/reviews/28cce7ebe9dc.jpg", "/reviews/b551a9b1ad09.jpg"],
        verified: true,
    },
    {
        id: 10,
        name: "Michael",
        location: "United States",
        date: "December 9, 2025",
        rating: 5,
        content: "fantastic, small group, Richard was great, lots of knowledge and stories, it was foggy, but I actually really enjoyed the ambiance of the fog and castles, beautiful pictures because of that. we changed the itinerary slightly because of winter and the substitute castle was beautiful and really enjoyed walking around it.",
        images: ["/reviews/31ebd9b380c6.jpg", "/reviews/ae5680d42b29.jpg", "/reviews/bf89d9e4dd99.jpg", "/reviews/c20e36181481.jpg"],
        verified: true,
    },
    {
        id: 11,
        name: "Indranil",
        location: "United Kingdom",
        date: "December 4, 2025",
        rating: 5,
        content: "The trip was great and Richard is a very good guide. With limited number of people he was able to offer flexibility and we were never rushed The snow-filled village of Chichmany with the motifs on the walls were simply magical. It was a nice gesture from Richard to provide us a gift package filled with local snacks of Bratislava Would highly recommend this tour",
        verified: true,
    },
    {
        id: 12,
        name: "Jake",
        location: "United Kingdom",
        date: "November 29, 2025",
        rating: 5,
        content: "We had a fantastic time, with lots of variety in activities and sights. Richard was very insightful, friendly and an overall great guide - I would highly recommend this trip to anyone looking to see a lot more of Slovakia outside of the capital.",
        verified: true,
    },
    {
        id: 13,
        name: "Giulia",
        location: "Italy",
        date: "November 16, 2025",
        rating: 5,
        content: "Esperienza fantastica. Thomas e Michael, nativi slovaccchi, sono state le nostre guide del tour, particolarmente professionali, educate e simpatiche. Il tour si svolge nel corso di una giornata e include la visita dei castelli piú caratteristici della Slovacchia. Durante il viaggio abbiamo fatto diverse soste, inclusa quella del pranzo in un cottage tipico slovacco, degustando diversi piatti della tradizione, e la degustazione di vini tipici slovacchi. Thomas e Michael si sono rivelate due guide molto preparate sulla storia nazionale, attente ai dettagli e alle richieste dei clienti, oltre che desiderose di far conoscere al turista la cultura e le tradizioni slovacche. A conclusione della giornata, Thomas e Michael ci hanno fatto un regalo, molto apprezzato. Viaggio confortevole e in sicurezza a bordo di un minivan. Attività assolutamente raccomandata.",
        verified: true,
    },
    {
        id: 14,
        name: "David",
        location: "United States",
        date: "November 4, 2025",
        rating: 5,
        content: "We hit the jackpot with this tour! Tomáš and Michal are absolute awesome people with enthusiasm and pride in their country. We were incredibly lucky to have them to ourselves showing us their beautiful country for the day. There is so much more to Slovakia than I would have imagined. These brothers did an outstanding job of highlighting a breadth of various aspects of Slovakia in a short time. Tomáš drove safely and confidently the whole day and Michal did most of the narration. Their hospitality and thoughtfulness was evident throughout. We experienced much more than I would have ever imagined and were able to see things through a local’s perspective. We came away with a profound admiration for Slovakia and two new Slovak friends.",
        images: ["/reviews/56260fd5d762.jpg", "/reviews/4660a5d77f6c.jpg", "/reviews/36b57671e004.jpg", "/reviews/a7060e88df5a.jpg"],
        verified: true,
    },
    {
        id: 15,
        name: "James",
        location: "United States",
        date: "September 5, 2025",
        rating: 5,
        content: "The trip was simply wonderful. We visited many unique places in one day, tried Slovak wines, and our guide even took us to lunch at a farmhouse where I tried the national dish! The UFO viewpoint at the end of the trip was simply WOW for me. What's more, all entrance fees to castles and viewpoints are included in the price, so we didn't have to worry about a thing. I recommend the trip, 10/10. When I come back to Slovakia, I will definitely contact Thomas :)",
        verified: true,
    },
    {
        id: 16,
        name: "Elisa",
        location: "United States",
        date: "August 9, 2025",
        rating: 5,
        content: "this was, by far, the best tour I have ever taken! the guides were incredibly kind, funny, and knowledgeable. Every single sight was nothing short of spectacular. the food (not included in the price but very very affordable) was delicious, and the car ride between stops was extremely comfortable. I left this tour feeling like I got a small, yet well rounded taste of Slovakia, and the beauty of this country!! thank you to both our guides for the best tour!! do yourself a favor and book this tour!!!",
        verified: true,
    },
];

// Curated mix shown on the homepage (newest, photo + 5-star preference).
export const featuredReviews: Review[] = [
    {
        id: 1,
        name: "GetYourGuide traveler",
        location: "Spain",
        date: "April 27, 2026",
        rating: 5,
        content: "Perfect thanks to our guide Richard",
        images: ["/reviews/7adf21d06ba3.jpg", "/reviews/73c544f6d309.jpg"],
        trip: "slovakia",
        verified: true,
    },
    {
        id: 2,
        name: "Marianna",
        location: "Italy",
        date: "December 12, 2025",
        rating: 5,
        content: "Un tour davvero pazzesco, che ha superato di gran lunga tutte le nostre aspettative! Abbiamo visitato luoghi meravigliosi, ognuno più suggestivo dell’altro. La nostra guida — e autista — Richard è stata una presenza impeccabile: preparatissimo, disponibile, gentile e sempre attento alle nostre esigenze. Ha arricchito ogni tappa con racconti, curiosità e spiegazioni davvero interessanti, rendendo l’esperienza ancora più speciale. Un viaggio che porteremo nel cuore e che consigliamo a chiunque voglia vivere qualcosa di unico. Ah e grazie per il regalo, graditissimo 😁",
        images: ["/reviews/8e69ab86081b.jpg", "/reviews/e477f1715d4d.jpg", "/reviews/6bd3ad681240.jpg", "/reviews/538faca8dfb1.jpg"],
        trip: "slovakia",
        verified: true,
    },
    {
        id: 3,
        name: "Renzo",
        location: "Spain",
        date: "December 10, 2025",
        rating: 5,
        content: "Ha sido una experiencia muy buena, a superado toda mis expectativas de lo que yo creía, destacó la paciencia y buena onda de nuestro Guía Richard, siempre atento con las dudas de cada uno. Gracias a este tour he tenido la oportunidad de conocer más lo que es Eslovaquia, recomiendo mucho",
        images: ["/reviews/478b935d2cac.jpg", "/reviews/c063e6e82829.jpg", "/reviews/28cce7ebe9dc.jpg", "/reviews/b551a9b1ad09.jpg"],
        trip: "slovakia",
        verified: true,
    },
    {
        id: 4,
        name: "Michael",
        location: "United States",
        date: "December 9, 2025",
        rating: 5,
        content: "fantastic, small group, Richard was great, lots of knowledge and stories, it was foggy, but I actually really enjoyed the ambiance of the fog and castles, beautiful pictures because of that. we changed the itinerary slightly because of winter and the substitute castle was beautiful and really enjoyed walking around it.",
        images: ["/reviews/31ebd9b380c6.jpg", "/reviews/ae5680d42b29.jpg", "/reviews/bf89d9e4dd99.jpg", "/reviews/c20e36181481.jpg"],
        trip: "slovakia",
        verified: true,
    },
    {
        id: 5,
        name: "Erik",
        location: "Netherlands",
        date: "December 7, 2025",
        rating: 5,
        content: "It was a great trip to beautiful valleys, the Melk monastery, the Traunsee and Salzburg. Tomas and Michael were really kind and good guides. they took time to explain about the different sight, and brought us to some of the less visited places alongst the way as well. I can really recommend their tours!",
        images: ["/reviews/6efb09ee483c.jpg", "/reviews/79d2a8e7f68f.jpg", "/reviews/3b9e9f3c8cc2.jpg", "/reviews/dee101bfec55.jpg"],
        trip: "austria",
        verified: true,
    },
    {
        id: 6,
        name: "David",
        location: "United States",
        date: "November 4, 2025",
        rating: 5,
        content: "We hit the jackpot with this tour! Tomáš and Michal are absolute awesome people with enthusiasm and pride in their country. We were incredibly lucky to have them to ourselves showing us their beautiful country for the day. There is so much more to Slovakia than I would have imagined. These brothers did an outstanding job of highlighting a breadth of various aspects of Slovakia in a short time. Tomáš drove safely and confidently the whole day and Michal did most of the narration. Their hospitality and thoughtfulness was evident throughout. We experienced much more than I would have ever imagined and were able to see things through a local’s perspective. We came away with a profound admiration for Slovakia and two new Slovak friends.",
        images: ["/reviews/56260fd5d762.jpg", "/reviews/4660a5d77f6c.jpg", "/reviews/36b57671e004.jpg", "/reviews/a7060e88df5a.jpg"],
        trip: "slovakia",
        verified: true,
    },
    {
        id: 7,
        name: "Arza",
        location: "Israel",
        date: "October 31, 2025",
        rating: 5,
        content: "It was an amazing trip! Breathtaking scenery, a wonderful atmosphere, and an unforgettable experience. Michael and Thomas were absolutely incredible - both as guides and as people. They were knowledgeable, kind, and always considerate. Thank you for the personal attention and care throughout the journey. We're already looking forward to the next adventures with you!",
        images: ["/reviews/3a18813fc1d6.jpg"],
        trip: "austria",
        verified: true,
    },
    {
        id: 8,
        name: "Tomescu",
        location: "Romania",
        date: "October 30, 2025",
        rating: 5,
        content: "Amazing trip! We've seen absolutely beautiful landscapes of the Danube, mountains, lakes, churches, vineyards. We were enchanted with great stories by our guide Richard, thanks to whom all went according to plan, perfectly organized. Salzburg was mesmerizing-its gardens, castle, chic shops were worth the long drive!",
        images: ["/reviews/39d9d7739e8c.jpg", "/reviews/61b89bca500c.jpg", "/reviews/0dc976fea32d.jpg", "/reviews/f48b2ff56a1b.jpg"],
        trip: "austria",
        verified: true,
    },
];
